<template>
  <div style="width: 100%; height: 680px;" class="overflow-auto px-12">
    <highcharts :options="chartOptions"></highcharts>
    <v-menu
        rounded="lg"
        :position-x="menuX"
        :position-y="menuY"
        :nudge-bottom="65"
        :nudge-left="6"
        :close-on-click="false"
        :close-on-content-click="false"
        v-model="menu"
    >
      <v-card :width="257">
        <v-card-text>
          <v-form ref="nodeForm" v-model="nodeFormIsValid">
            <v-text-field
                class="rounded-lg"
                autofocus
                dense
                outlined
                label="Title"
                hide-details
                :rules="rules"
                v-model="selectedNode.name"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="error"
              icon
              small
              :disabled="isRoot"
              @click="deleteNode()"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn
                  color="primary"
                  icon
                  small
                  :disabled="selectedNode.is_hanging"
                  v-on="on"
                  @click="addNode(true)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <div>Create new child node</div>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn color="back" text @click="closeMenu()">
            Close
          </v-btn>
          <v-btn color="success" text @click="saveNode()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import Sankey from 'highcharts/modules/sankey';
import Access from 'highcharts/modules/accessibility';
import Exporting from 'highcharts/modules/exporting';
import Organization from 'highcharts/modules/organization';
import OrgChartOptions from "@/views/Tools/SecPeak/Components/OrgChartOptions";
import {v4 as uuid} from 'uuid';

Sankey(Highcharts);
Access(Highcharts);
Exporting(Highcharts);
Organization(Highcharts);

export default {
  name: "HighOrgChart",
  mixins: [OrgChartOptions],
  components: {
    highcharts: Chart
  },
  data() {
    return {
      menu: false,
      menuX: null,
      menuY: null,
      nodeFormIsValid: false,
      rules: [(val) => !!val || 'This field is required'],
      selectedNode: {
        id: null,
        name: '',
        linksTo: {from: null},
        linksFrom: [],
      },
    }
  },
  computed: {
    isRoot() {
      return this.selectedNode.id === this.selectedNode.linksTo.from;
    }
  },
  methods: {
    initData() {
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[0].nodes = [];
      this.generateInitialNodes();
    },
    generateInitialNodes() {
      const rootId = uuid();

      Array.from(Array(6)).forEach((_, index) => {
        const nodeId = uuid();
        let node = {
          id: null,
          name: 'Click to complete',
        };

        if (index === 0) {
          node.id = rootId;
          node.name = 'CEO';
        } else {
          node.id = nodeId;
          this.$set(node, 'layout', 'hanging');
        }

        this.$set(this.chartOptions.series[0].nodes, this.chartOptions.series[0].nodes.length, node);

        if (index === 0) {
          this.linkInitialNode(rootId, rootId);
        } else {
          this.linkInitialNode(rootId, nodeId);
        }
      });
    },
    linkInitialNode(pid, id) {
      this.$set(this.chartOptions.series[0].data, this.chartOptions.series[0].data.length, [pid, id]);
    },
    deleteNode() {
      this.deleteChildNodes();

      let index = this.chartOptions.series[0].nodes.findIndex(({id}) => id === this.selectedNode.id);
      this.$delete(this.chartOptions.series[0].data, index);
      this.$delete(this.chartOptions.series[0].nodes, index);

      this.closeMenu();
    },
    deleteChildNodes() {
      this.selectedNode.linksFrom.forEach((uuid) => {
        let nodeIndex = this.chartOptions.series[0].nodes.findIndex(({id}) => id === uuid);
        this.$delete(this.chartOptions.series[0].nodes, nodeIndex);
        this.$delete(this.chartOptions.series[0].data, nodeIndex);
      });
    },
    addNode() {
      let node = {
        id: uuid(),
        pid: this.selectedNode.id,
        name: 'Click to complete',
        layout: 'hanging',
      };

      this.$set(this.chartOptions.series[0].nodes, this.chartOptions.series[0].nodes.length, node);
      this.$set(this.chartOptions.series[0].data, this.chartOptions.series[0].data.length, [node.pid, node.id]);

      this.closeMenu();
    },
    closeMenu() {
      this.menu = false;

      if (this.$refs['nodeForm']) {
        this.$refs.nodeForm.reset();
        this.$refs.nodeForm.resetValidation();
      }

    },
    saveNode() {
      let node = this.chartOptions.series[0].nodes.find(({id}) => id === this.selectedNode.id);
      this.$set(node, 'name', this.selectedNode.name);

      this.closeMenu();
    },
    reset() {
      this.initData();
    },
    refreshChart() {
      setTimeout(() => {
        this.chartOptions.series[0].data = JSON.parse(JSON.stringify(this.chartOptions.series[0].data));
      }, 100);
    },
  },
  mounted() {
    this.initData();
    window.addEventListener('resize', this.refreshChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.refreshChart);
  },
}
</script>

<style scoped>

</style>